export default __webpack_public_path__ + "static/media/NavLogo_footer_white.32d0aa3c.svg";